// export const REACT_APP_API_PORT = "http://localhost:8000/backend/api/"
// export const IMAGE_URL = "http://localhost:8000/backend/uploads/images/"
// export const VIDEO_URL = "http://localhost:8000/backend/uploads/videos/"

// export const PROMPT_VIDEO_URL = "http://localhost:8000/backend/uploads/videos/" 


// .in
// export const REACT_APP_API_PORT = "https://nextfutureai.in/nodebackend/backend/api/"
// export const IMAGE_URL = "https://nextfutureai.in/nodebackend/backend/uploads/images/"
// export const VIDEO_URL = "https://nextfutureai.in/nodebackend/backend/uploads/videos/"
// export const PROMPT_VIDEO_URL = "https://nextfutureai.in/nodebackend/backend/uploads/videos/" 

// .com
export const REACT_APP_API_PORT = "https://nextfutureai.com/nodebackend/backend/api/"
export const IMAGE_URL = "https://nextfutureai.com/nodebackend/backend/uploads/images/"
export const VIDEO_URL = "https://nextfutureai.com/nodebackend/backend/uploads/videos/"
export const PROMPT_VIDEO_URL = "https://nextfutureai.com/nodebackend/backend/uploads/videos/"


// export const REACT_APP_API_PORT = "https://dev.nextfutureai.com/backend/api/"
// export const IMAGE_URL = "https://dev.nextfutureai.com/backend/uploads/images/"
// export const VIDEO_URL = "https://dev.nextfutureai.com/backend/uploads/videos/"
// export const PROMPT_VIDEO_URL = "https://dev.nextfutureai.com/backend/uploads/videos/"